import React, { useState } from "react";
import { get, isEmpty } from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faClock } from "@fortawesome/pro-light-svg-icons";
import { usCurrency } from "../../../../utils";
import moment from "moment";

const data = {
  bankFundings: [
    {
      bankName: "Some",
      bankFund: 1000,
    },
    {
      bankName: "Koewe",
      bankFund: 1000,
    },
    {
      bankName: "Kerw",
      bankFund: 1000,
    },
    {
      bankName: "WRwef",
      bankFund: 1000,
    },
  ],
};
const PayeeCard = () => {
  return (
    <div className="transaction-history-payee-inner-box">
      <div className="cash-distribution-transaction-history">
        Cash distribution <span> - Self</span>
      </div>
      <div className="bottom-payee-card">
        <div className="bottom-payee-card-text-main">
          <div className="text-area-payee">Somethy Erlng</div>
          <div className="secondary-text-payee">payment method</div>
        </div>
        <div className="bottom-payee-card-text-main">
          <div className="text-area-payee">Somethy Erlng</div>
          <div className="secondary-text-payee">payment method</div>
        </div>
        <div className="seperator-transaction-history-detail"></div>
        <div className="block-payee">
          <div className="bottom-payee-card-text-main">
            <div className="secondary-text-payee">Somethy Erlng</div>
            <div className="text-area-payee">payment method</div>
          </div>
          <div className="seperator-transaction-history-detail"></div>
          <div className="bottom-payee-card-text-main">
            <div className="secondary-text-payee">Somethy Erlng</div>
            <div className="text-area-payee">payment method</div>
          </div>
        </div>
      </div>
    </div>
  );
};
export const LoanRepaymentDetails = (props) => {
  return (
    <div className="transaction-history-withdrawal">
      <div className="transaction-history-withdrawal-header">
        Loan Repayment Detail
      </div>

      <div className="loan-transaction-history-main-container">
        <div className="header-loan-transaction">General Purpose Loan</div>
        <div className="inner-content-loans">
          <div className="transaction-history-withdrawal-header">
            Repayment amount
          </div>
          <div className="transaction-history-withdrawal-header">$ 2200</div>
        </div>
        <div className="inner-content-loans">
          <div className="response-names-transaction">TPA fee</div>
          <div className="response-names-transaction">$ 2</div>
        </div>
        <div className="inner-content-loans">
          <div className="response-names-transaction">EFT fee</div>
          <div className="response-names-transaction">$ 10</div>
        </div>
        <div className="inner-content-loans bb-loan">
          <div className="total-fee-amount-text">Total fee amount</div>
          <div className="total-fee-amount-text">$ 12</div>
        </div>
        <div className="inner-content-loans">
          <div className="transaction-history-withdrawal-header">
            Net amount
          </div>
          <div className="transaction-history-withdrawal-header">$ 2212</div>
        </div>
      </div>
    </div>
  );
};
